// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed-tabs-bar{background:#fff;position:-webkit-sticky;position:sticky;top:0;z-index:2}.v-slide-group__next.v-slide-group__next--disabled,.v-slide-group__prev.v-slide-group__prev--disabled{display:none}.v-carousel__item{height:auto!important}video::-internal-media-controls-download-button{display:none}video::-webkit-media-controls-enclosure{overflow:hidden}video::-webkit-media-controls-panel{width:calc(100% + 30px)}.v-carousel__controls{left:15%!important;width:70%!important}", ""]);
// Exports
module.exports = exports;
